import { Drawer as AntdDranwer } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const Drawer = _ref => {
  let {
    children,
    className,
    highest = true,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(AntdDranwer, {
    rootClassName: classNames(className, 'drawer', {
      highest
    }),
    closable: false,
    ...props,
    children: /*#__PURE__*/_jsx("div", {
      className: "drawer-content-wrap",
      children: children
    })
  });
};
export default Drawer;